// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  WorldNotification,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  recipient: __t.identity(),
  connection: __t.connectionId(),
  tick: __t.u32(),
  get notification() {
    return WorldNotification;
  },
});
